import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// The guardian's home is the list of supervised profiles. Local-first (SQLite
// reads in ~ms), so it is shipped in the main bundle (not lazy) and painted
// directly with the shell — a skeleton would only cause a flash + remount.
import { SupervisionDashboard } from "@/features/supervision/components/supervision-dashboard";

function DashboardPage() {
  return <SupervisionDashboard />;
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: DashboardPage,
});
